// extracted by mini-css-extract-plugin
export var carrierTab = "_4c-0";
export var carrierTabActive = "_4c-1 _4c-0";
export var carrierTabInactive = "_4c-2 _4c-0";
export var carrierTabLabel = "_4c-3";
export var carrierTabLabelActive = "_4c-4 _4c-3";
export var carrierTabLabelInactive = "_4c-5 _4c-3";
export var carrierTabPercentage = "_4c-6";
export var carrierTabPercentageActive = "_4c-7 _4c-6";
export var carrierTabPercentageInactive = "_4c-8 _4c-6";
export var carrierTabWinnable = "_4c-9";
export var carrierTabWinnableActive = "_4c-a _4c-9";
export var carrierTabWinnableInactive = "_4c-b _4c-9";
export var comparisonContainer = "_4c-d";
export var missingRateButton = "_4c-n";
export var missingRateButtonActive = "_4c-o _4c-n";
export var missingRateButtonInactive = "_4c-p _4c-n";
export var missingRateButtonLabel = "_4c-q";
export var missingRateButtonLabelActive = "_4c-r _4c-q";
export var missingRateButtonLabelInactive = "_4c-s _4c-q";
export var sidebar = "_4c-c";
export var strategyButton = "_4c-e";
export var strategyButtonActive = "_4c-f _4c-e";
export var strategyButtonDescription = "_4c-k";
export var strategyButtonDescriptionActive = "_4c-l _4c-k";
export var strategyButtonDescriptionInactive = "_4c-m _4c-k";
export var strategyButtonInactive = "_4c-g _4c-e";
export var strategyButtonLabel = "_4c-h";
export var strategyButtonLabelActive = "_4c-i _4c-h";
export var strategyButtonLabelInactive = "_4c-j _4c-h";
export var unitToggleButton = "_4c-t";
export var unitToggleButtonActive = "_4c-u _4c-t";
export var unitToggleButtonInactive = "_4c-v _4c-t";
export var unitToggleButtonLabel = "_4c-w";
export var unitToggleButtonLabelActive = "_4c-x _4c-w";
export var unitToggleButtonLabelInactive = "_4c-y _4c-w";